<template>
  <el-drawer
    title="人员详情"
    append-to-body
    :close-on-press-escape="false"
    :visible.sync="show"
    size="45%"
    direction="rtl">
    <div
      v-loading="loading"
      class="detail-drawer-wrap">
      <el-form label-width="85px">
        <el-form-item label="人员姓名：">{{ ruleForm.name }}</el-form-item>
        <el-form-item label="联系电话：">{{ ruleForm.phone }}</el-form-item>
        <el-form-item label="人员头像：">
          <image-list
            :list="ruleForm.headPicture"
            :listType="3" />
        </el-form-item>
        <el-form-item label="人员职称：">{{ ruleForm.work }}</el-form-item>
        <el-form-item label="上架状态：">{{ ruleForm.status === 1 ? '已上架' : '未上架' }}</el-form-item>
        <el-form-item label="排序值：">{{ ruleForm.sortNumber }}</el-form-item>
        <el-form-item label="人员简介：">
          <div style="line-height: 1.8;">{{ ruleForm.briefIntroduction }}</div>
        </el-form-item>
        <el-form-item label="图文介绍：">
          <desc-images v-model="ruleForm.detailedImages"></desc-images>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>
<script>
import Expert from '@/service/expert'
import ImageList from '@/components/image-list.vue'
import DescImages from '@/components/public/desc-images.vue'
export default {
  name: 'ExpertDetailDrawer',
  components: { ImageList, DescImages },
  data() {
    return { show: false, loading: false, config: { id: null }, ruleForm: { headPicture: '', detailedImages: [] }}
  },
  methods: {
    fetchInfo() {
      this.loading = true
      Expert.getexpert({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, detailedImages } = res.data
          if (result === 0) {
            this.$set(this, 'ruleForm', {
              ...res.data,
              detailedImages: this.$splitImage(detailedImages)
            })
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(options) {
      this.config = { ...this.config, ...options }
      this.show = true
      this.fetchInfo()
    }
  }
}
</script>
<style lang="stylus" scoped>
  .images-wrap {
    width 256px
    height 400px
    overflow-y auto
  }
</style>
